function unwrap(value) {
  return value.trim().replace(/^"(.*)"$/, '$1').trim();
}

// Content-Disposition 헤더에서 첨부 파일명을 추출한다.
// 파일명에 한글이 포함되므로 RFC 5987 filename*(UTF-8 percent-encoded)을 우선 사용하고,
// 디코딩에 실패하면 ASCII 대체본인 filename으로 폴백한다.
export function parseAttachmentFileName(contentDisposition, fallback = 'download.xlsx') {
  if (!contentDisposition) {
    return fallback;
  }

  const extended = /filename\*\s*=\s*[^']*'[^']*'([^;]+)/i.exec(contentDisposition);
  if (extended) {
    try {
      const decoded = decodeURIComponent(unwrap(extended[1]));
      if (decoded !== '') {
        return decoded;
      }
    } catch (e) {
      // 잘못된 percent-encoding인 경우 아래 ASCII filename으로 폴백한다.
    }
  }

  const ascii = /filename\s*=\s*("[^"]*"|[^;]+)/i.exec(contentDisposition);
  if (ascii) {
    const name = unwrap(ascii[1]);
    if (name !== '') {
      return name;
    }
  }

  return fallback;
}
